import { Z as fallback, Y as escape_html, $ as attr, a1 as bind_props, S as pop, Q as push } from "./index.js";
import { X as XIcon } from "./XIcon.js";
function DRepDetails($$payload, $$props) {
  push();
  let drep = fallback($$props["drep"], () => ({}), true);
  let show = fallback($$props["show"], false);
  if (show) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<div class="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center"><div class="bg-white p-4 rounded shadow-lg mx-auto flex flex-col items-center"><div class="text-right w-full"><button>`;
    XIcon($$payload, { class: "cursor-pointer" });
    $$payload.out += `<!----></button></div> <div class="mt-4 text-sm text-gray-700 break-words w-full"><div class="text-lg font-medium text-gray-700">DRep Id :</div> <div>${escape_html(drep.drep_id)}</div></div> <div class="mt-4 text-sm text-gray-700 break-words w-full"><div class="text-lg font-medium text-gray-700">DRep Hash :</div> <div>${escape_html(drep.drep_hash)}</div></div> `;
    if (drep.deposit) {
      $$payload.out += "<!--[-->";
      $$payload.out += `<div class="mt-4 text-sm text-gray-700 break-words w-full"><div class="text-lg font-medium text-gray-700">Deposit :</div> <div>${escape_html(drep.deposit)}</div></div>`;
    } else {
      $$payload.out += "<!--[!-->";
    }
    $$payload.out += `<!--]--> `;
    if (drep.anchor_hash) {
      $$payload.out += "<!--[-->";
      $$payload.out += `<div class="mt-4 text-sm text-gray-700 break-words w-full"><div class="text-lg font-medium text-gray-700">Anchor Hash :</div> <div>${escape_html(drep.anchor_hash)}</div></div>`;
    } else {
      $$payload.out += "<!--[!-->";
    }
    $$payload.out += `<!--]--> `;
    if (drep.anchor_url) {
      $$payload.out += "<!--[-->";
      $$payload.out += `<div class="mt-4 text-sm text-gray-700 break-words w-full"><div class="text-lg font-medium text-gray-700">Anchor URL :</div> <div><a${attr("href", drep.anchor_url)} target="_blank" class="text-blue-500">${escape_html(drep.anchor_url)}</a></div></div>`;
    } else {
      $$payload.out += "<!--[!-->";
    }
    $$payload.out += `<!--]--></div></div>`;
  } else {
    $$payload.out += "<!--[!-->";
  }
  $$payload.out += `<!--]-->`;
  bind_props($$props, { drep, show });
  pop();
}
export {
  DRepDetails as D
};
